import { render, staticRenderFns } from "./eventsfilterdata.vue?vue&type=template&id=613f04f7&scoped=true"
import script from "./eventsfilterdata.vue?vue&type=script&lang=js"
export * from "./eventsfilterdata.vue?vue&type=script&lang=js"
import style0 from "./eventsfilterdata.vue?vue&type=style&index=0&id=613f04f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f04f7",
  null
  
)

export default component.exports